/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IActionContext, IRequestContext, IRequestContextParams } from '@msdyn365-commerce/core-internal';
import { ProductCatalog } from '@msdyn365-commerce/retail-proxy';
import { CatalogsInput, getCatalogActionDataAction } from './actions/get-catalogs';

/**
 * Returns catalog name for a given catalog id
 * @param context Action Context
 * @param context Catalog Id
 */
export const getCatalogName = async (context: IActionContext, catalogId: number): Promise<string> => {
    if (!context || !context.requestContext || !context.requestContext.apiSettings) {
        return '';
    }

    const customerAccountNumber = context.requestContext.user.customerAccountNumber;
    const productCatalogs = await getCatalogActionDataAction(new CatalogsInput(context.requestContext, customerAccountNumber), context);

    return findCatalogName(productCatalogs, catalogId);
};

/**
 * Returns true if data action cache needs to be bypassed
 * @param requestContext rendering context
 * @returns cachebypass status
 */
export const shouldByPassCache = (requestContext: IRequestContext) => {
    return (requestContext.query && !!requestContext.query.cachebypass) || isPageInsightsEnabled(requestContext.params);
};

const isPageInsightsEnabled = (params: IRequestContextParams): boolean => {
    return params?.pageInsights === 'all' || params?.pageInsights === 'info' || params?.pageInsights === 'error';
};

/**
 * Matches the catalog if with the productCatalogs response and returns catalog name
 * @param productCatalogs Product catalogs response
 * @param catalogId Catalog id to search in Product catalogs response
 * @returns Catalog name
 */
export const findCatalogName = (productCatalogs: ProductCatalog[], catalogId: number): string => {
    let catalogName = '';
    productCatalogs &&
        productCatalogs.forEach((catalog: ProductCatalog) => {
            if (catalog.RecordId === catalogId && catalog.Name) {
                catalogName = catalog.Name;
            }
        });
    return catalogName;
};
